import {InternalToolsModulePermissionCodes, LaunchModulePermissionCodes} from 'utils/types';
import {defineTabDef} from 'utils/helpers';

export const launchTabs = defineTabDef({
  campaign_form: {
    tabName: 'campaign_form',
    tabTitle: 'Campaign Form',
    requiredAnyPermission: [LaunchModulePermissionCodes.view_launch],
  },
  sales_dataset: {
    tabName: 'sales_dataset',
    tabTitle: 'Sales Dataset',
    requiredAnyPermission: [LaunchModulePermissionCodes.view_sales_dataset],
  },
  measurement_plan: {
    tabName: 'measurement_plan',
    tabTitle: 'Measurement Plan',
    requiredAnyPermission: [LaunchModulePermissionCodes.view_measurement_plan],
  },
  data_health: {
    tabName: 'data_health',
    tabTitle: 'Data Health',
    requiredAnyPermission: [InternalToolsModulePermissionCodes.view_internal_tools],
  },
  deliverables: {
    tabName: 'deliverables',
    tabTitle: 'Deliverables',
    requiredAnyPermission: [LaunchModulePermissionCodes.view_deliverables],
  },
  campaign_image_picker: {
    tabName: 'campaign_image_picker',
    tabTitle: 'Campaign Image Picker',
    requiredAnyPermission: [LaunchModulePermissionCodes.view_campaign_image_picker],
  },
  settings: {
    tabName: 'settings',
    tabTitle: 'Settings',
    requiredAnyPermission: [LaunchModulePermissionCodes.view_campaign_settings],
  },
  user_access: {
    tabName: 'user_access',
    tabTitle: 'User Access',
    requiredAnyPermission: [LaunchModulePermissionCodes.view_user_access],
  },
  intake_form: {
    tabName: 'intake_form',
    tabTitle: 'Intake Form',
    requiredAnyPermission: [LaunchModulePermissionCodes.view_intake_form],
  },
  transfer_campaign_ownership: {
    tabName: 'transfer_campaign_ownership',
    tabTitle: 'Transfer Campaign Ownership',
    requiredAnyPermission: [LaunchModulePermissionCodes.transfer_campaign_ownership],
  },
  hubspot: {
    tabName: 'hubspot',
    tabTitle: 'HubSpot',
    requiredAnyPermission: [],
    requireStaff: true,
  },
} as const);
